import { app, translate } from '../app';
import { Container } from './container';
import { languages } from '../locale';
import { translations } from '../translations';

export function BlockContact(props: { block: BlockContact }) {
  const { block } = props;
  const locale = (languages[app.locale]?.zendesk as string) ?? app.locale;
  const isRTL = languages[app.locale]?.rtl;

  return (
    <Container className={isRTL ? 'rtl' : ''}>
      <h1 className={`text-3xl lg:text-4xl font-bold mb-4 text-black ${isRTL ? 'text-right' : 'text-left'}`} style={{ direction: isRTL ? "rtl" : "ltr" }}>
        {translate(translations.contactForm)}
      </h1>
      <p className={`text-neutral-icon text-base lg:text-lg mb-8 ${isRTL ? 'text-right' : 'text-left'}`} style={{ direction: isRTL ? "rtl" : "ltr" }}> {translate(translations.contactFormDescription)} </p>
    <form className="grid grid-cols-1 gap-6 md:grid-cols-2" onSubmit={(e) => e.preventDefault()}>
        <div className="flex flex-col">
          <label htmlFor="name" className="mb-2 text-sm font-medium text-black">
            {translate(translations.name)}
          </label>
          <input id="name" name="name" type="text" placeholder={translate(translations.name)}
            className="p-2 border border-gray-300 rounded-md w-full max-w-xs mx-auto md:mx-0 md:max-w-full text-black placeholder-gray-500"/>
        </div>
        <div className="flex flex-col">
          <label htmlFor="email" className="mb-2 text-sm font-medium text-black">
            {translate(translations.email)}
          </label>
          <input id="email" name="email" type="email" placeholder={translate(translations.email)} className="p-2 border border-gray-300 rounded-md w-full max-w-xs mx-auto md:mx-0 md:max-w-full text-black placeholder-gray-500"/>
        </div>
        <div className="flex flex-col md:col-span-2">
          <label htmlFor="subject" className="mb-2 text-sm font-medium text-black">
            {translate(translations.subject)}
          </label>
          <input id="subject" name="subject" type="text" placeholder={translate(translations.subjectOfYourMessage)}
            className="p-2 border border-gray-300 rounded-md w-full max-w-xs mx-auto md:mx-0 md:max-w-full text-black placeholder-gray-500"/>
        </div>
        <div className="flex flex-col md:col-span-2">
          <label htmlFor="message" className="mb-2 text-sm font-medium text-black">
            {translate(translations.message)}
          </label>
          <textarea id="message" name="message" placeholder={translate(translations.yourMessageHere)}
            rows={6} className="p-2 border border-gray-300 rounded-md w-full max-w-xs mx-auto md:mx-0 md:max-w-full text-black placeholder-gray-500"/>
        </div>
        <div className="md:col-span-2 text-left">
          <button type='submit' className='form-submit'>
            {translate(translations.submit)}
          </button>
        </div>
      </form>
    </Container>
  );
}
